
const config =
{
    version: "Roctec C8762-8765, v2.0.3",
    hash: "75f51b23c7f0af5362c045606a8d9ec46b6817d52f1d372eb783957e530bb4a5",
    traintype_arr: [
        { value: "all", name: "All Train" },
        { value: "c", name: "C-train" },
        { value: "q", name: "Q-train" },
        { value: "m", name: "M-train" },
        { value: "k", name: "K-train" },
        { value: "caf", name: "Caf-train" },
        { value: "r", name: "R-train" },

    ],
    index_label: [
        { content: "below 110 People", color: "#39AC50" },
        { content: "110 People to 240 People", color: "#F69D00" },
        { content: "over 240 People", color: "#E41630" },
    ],
    mtr_openapi: {
        url: "https://rt.data.gov.hk/v1/transport/mtr/getSchedule.php", // ?line=TKL&sta=TKO
    },
    isl_config: {
        line: "ISL",
        line_full: "Island Line",
        web_api: "https://sdz2h3zx17.execute-api.ap-east-1.amazonaws.com/default/trainLoads",
        web_api_key: "gRSyLCpSg97wxGIAhaovD4bN0fY4Z0jYa5xeoEn9",
        stations: ["KET", "HKU", "SYP", "SHW", "CEN", "ADM", "WAC", "CAB", "TIH", "FOH", "NOP", "QUB", "TAK", "SWH", "SKW", "HFC", "CHW",],
        up_trick_dest_stations: ["CHW"],
        down_trick_dest_stations: ["KET"],
        line_color: "#0860a8",
    },
    // tkl_config: {
    //     line: "TKL",
    //     line_full: "Tseung Kwan O Line",
    //     web_api: "https://ylvae4pn4e.execute-api.ap-east-1.amazonaws.com/default/trainLoads",
    //     web_api_key: "N6lAPnCJUt5nVFX1vNUHm7yGBqXtJiqP6xfndhu6",
    //     stations: ["NOP", "QUB", "YAT", "TIK", "TKO", "HAH", "POA", "LHP",],
    //     up_trick_dest_stations: ["POA", "LHP"],
    //     down_trick_dest_stations: ["TIK", "NOP"],
    //     line_color: "#6b208b",
    // },
    // tcl_config: {
    //     line: "TCL",
    //     line_full: "Tung Chung Line",
    //     web_api: "https://mtr-tcl-trainload-api.rocteccloud.com/api/trainLoads",
    //     web_api_key: "LqKX1iHtfm3hFNCluSUlp6FoSAjjF6Nm5ZrMy5av",
    //     stations: ["HOK", "KOW", "OLY", "NAC", "LAK", "TSY", "SUN", "TUC",],
    //     up_trick_dest_stations: ["TUC"],
    //     down_trick_dest_stations: ["HOK"],
    //     line_color: "#fe7f1d",
    // },
    // ktl_config: {
    //     line: "KTL",
    //     line_full: "Kwun Tong Line",
    //     web_api: "https://3nx7c25ob6.execute-api.ap-east-1.amazonaws.com/trainLoads",
    //     web_api_key: "",
    //     stations: ["WHA", "HOM", "YMT", "MOK", "PRE", "SKM", "KOT", "LOF", "WTS", "DIH", "CHH", "KOB", "NTK", "KWT", "LAT", "YAT", "TIK",],
    //     up_trick_dest_stations: ["TIK"],
    //     down_trick_dest_stations: ["WHA"],
    //     line_color: "#1a9431",
    // },
    // ael_config: {
    //     line: "AEL",
    //     line_full: "Airport Express",
    //     web_api: "https://8adi7ufxzb.execute-api.ap-east-1.amazonaws.com/default/trainLoads",
    //     web_api_key: "Tn6aIZQGBq2k0ts2kWOAG9AZz2j6L8JQ7KFL2BN9",
    //     stations: ["HOK", "KOW", "TSY", "AIR", "AWE",],
    //     up_trick_dest_stations: ["AIR", "AWE"],
    //     down_trick_dest_stations: ["HOK"],
    //     line_color: "#1c7670",
    // },
    // tml_config: {
    //     line: "TML",
    //     line_full: "Tuen Ma Line",
    //     web_api: "",
    //     web_api_key: "",
    //     stations: ["WKS", "MOS", "HEO", "TSH", "SHM", "CIO", "STW", "CKT", "TAW", "HIK", "DIH", "KAT", "SUW", "TKW", "HOM", "HUH", "ETS", "AUS", "NAC", "MEF", "TWW", "KSR", "YUL", "LOP", "TIS", "SIH", "TUM",],
    //     up_trick_dest_stations: ["TUM"],
    //     down_trick_dest_stations: ["WKS"],
    //     line_color: "#9a3b26",
    // },
    // eal_config: {
    //     line: "EAL",
    //     line_full: "East Rail Line",
    //     web_api: "",
    //     web_api_key: "",
    //     stations: ["ADM", "EXC", "HUH", "MKK", "KOT", "TAW", "SHT", "FOT", "RAC", "UNI", "TAP", "TWO", "FAN", "SHS", "LOW", "LMC",],
    //     up_trick_dest_stations: ["LMC", "LOW", "SHS", "TAP", "RAC", "FOT", "SHT"],
    //     down_trick_dest_stations: ["ADM", "HUH", "MKK"],
    //     line_color: "#53b7e8",
    // },
    // sil_config: {
    //     line: "SIL",
    //     line_full: "South Island Line",
    //     web_api: "",
    //     web_api_key: "",
    //     stations: ["ADM", "OCP", "WCH", "LET", "SOH",],
    //     up_trick_dest_stations: ["SOH"],
    //     down_trick_dest_stations: ["ADM"],
    //     line_color: "#b5bd00",
    // },
    twl_config: {
        line: "TWL",
        line_full: "Tsuen Wan Line",
        web_api: "https://hrbt75qk60.execute-api.ap-east-1.amazonaws.com/default/trainLoads",
        web_api_key: "cWEnQqRK0taxxMVCMpNHK3kqQgcTB28tv3lPJRvb",
        stations: ["CEN", "ADM", "TST", "JOR", "YMT", "MOK", "PRE", "SSP", "CSW", "LCK", "MEF", "LAK", "KWF", "KWH", "TWH", "TSW",],
        up_trick_dest_stations: ["TSW"],
        down_trick_dest_stations: ["CEN"],
        line_color: "#ff0000",
    },
    // nsl_config: {
    //     line: "NSL",
    //     line_full: "North South Line",
    //     web_api: "",
    //     web_api_key: "",
    //     stations: [],
    //     up_trick_dest_stations: [],
    //     down_trick_dest_stations: [],
    //     line_color: "#0860a8",
    // },
}

export default config;